<template><div><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-bgs-{n}</code> to control the size of element's background image.</p>
<code-example custom class="d-d-grid d-g-200 d-g-cols4 d-p-200 d-bgc-secondary" source-code='&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-contain&quot; style=&quot;background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgs-contain&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-cover&quot; style=&quot;background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgs-cover&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var&quot; style=&quot;background-image: url(&#39;/assets/images/puffin.jpg&#39;); --bgg-size: 65% 65%;&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgs-var&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-auto d-bgp-center&quot; style=&quot;background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgs-auto&lt;/dt-text&gt;
&lt;/dt-stack&gt;
&lt;dt-stack align=&quot;center&quot; class=&quot;d-g-50&quot;&gt;
  &lt;div class=&quot;d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-unset&quot; style=&quot;background-image: url(&#39;/assets/images/puffin.jpg&#39;);&quot;&gt;&lt;/div&gt;
  &lt;dt-text as=&quot;code&quot; kind=&quot;code&quot; size=&quot;100&quot;&gt;d-bgs-unset&lt;/dt-text&gt;
&lt;/dt-stack&gt;'>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-contain" style="background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgs-contain</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-cover" style="background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgs-cover</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-var" style="background-image: url('/assets/images/puffin.jpg'); --bgg-size: 65% 65%;"></div>
  <dt-text as="code" kind="code" size="100">d-bgs-var</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-auto d-bgp-center" style="background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgs-auto</dt-text>
</dt-stack>
<dt-stack align="center" class="d-g-50">
  <div class="d-size-200 d-bgc-moderate d-bar-400 d-of-hidden d-bgr-none d-bgs-unset" style="background-image: url('/assets/images/puffin.jpg');"></div>
  <dt-text as="code" kind="code" size="100">d-bgs-unset</dt-text>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="i in sizes">
        <th scope="row" class="d-code--sm d-docsite-code">.d-bgp-{{ i }}</th>
        <td class="d-code--sm">
          background-size:
            <span v-if="i === 'var'"> var(--bgg-size, 100% 100%); </span>
            <span v-else >{{ i }} !important; </span>
        </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  const sizes = ['contain', 'cover', 'var', 'auto', 'unset'];
</script>